import React from 'react';

import { SwipeableContext } from 'ha/modules/SwipeableSlider';
import { VirtualizeSwipeableViews } from './VirtualizeSwipeableViews';

interface SlideRendererParams {
  index: number;
  key: number;
}

type SlideRenderer = (p: SlideRendererParams) => React.ReactNode | null;

interface Props {
  // a function in charge of rendering the slides given an index
  slideRenderer: SlideRenderer;
  disabled?: boolean;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  slideStyle?: React.CSSProperties;
}

const SwipeableViewsContainer: React.FC<Props> = ({
  disabled = false,
  slideRenderer,
  style = null,
  containerStyle = null,
  slideStyle = {
    overflowY: 'hidden',
  },
}) => {
  const { total, slideIndex, handleChangeSlideIndex } =
    React.useContext(SwipeableContext);

  // number ot slides to pre-rendered depending on total slides count
  const slidesToPreRenderCount = total >= 4 ? 2 : total >= 2 ? 1 : 0;

  return (
    <VirtualizeSwipeableViews
      disabled={disabled || total === 1}
      index={slideIndex}
      onChangeIndex={handleChangeSlideIndex}
      slideRenderer={slideRenderer}
      enableMouseEvents
      data-test-locator="gallery-swipeable-views"
      style={style}
      containerStyle={containerStyle}
      slideStyle={slideStyle}
      overscanSlideAfter={slidesToPreRenderCount}
      overscanSlideBefore={slidesToPreRenderCount}
    />
  );
};

export { SwipeableViewsContainer };
